module.exports = __webpack_public_path__ + "static/brand-768e53774f63906883abf4fb183cc8aa.png";